import { CardErrorHandlingBody } from '../../sections/card-error-handling/card-error-handling-body';
import { CardErrorHandlingHeader } from '../../sections/card-error-handling/card-error-handling-header';
import React from 'react';
import { Card, Container } from '../../shared';
import './inactive-handling.scss';
export var InactiveHandling = function () {
    return (React.createElement("section", null,
        React.createElement(Container, null,
            React.createElement("div", { className: "c-inactive-account u-mt-6" },
                React.createElement(Card, null,
                    React.createElement(CardErrorHandlingHeader, { icon: "exclamation" }),
                    React.createElement(CardErrorHandlingBody, { title: "You don't have permission", content: "Please contact your system admin if you would like more information." })),
                ' '))));
};
